import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ROLE_CLAIM = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

type JwtPayloadWithRoles = {
	[ROLE_CLAIM]?: string | string[];
	exp?: number;
};

function getRolesFromToken(token: string): string[] {
	try {
		const decoded = jwtDecode<JwtPayloadWithRoles>(token);
		const roles = decoded[ROLE_CLAIM];
		if (!roles) return [];
		return Array.isArray(roles) ? roles : [roles];
	} catch {
		return [];
	}
}

export default function RequireAdmin({ children }: { children: React.ReactNode }) {
	const token = localStorage.getItem('authToken');
	if (!token) return <Navigate to="/login" replace />;

	const roles = getRolesFromToken(token);
	const canAccess = roles.includes('Admin') || roles.includes('Superadmin');

	return canAccess ? <>{children}</> : <Navigate to="/" replace />;
}


